(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["oriade-editorial-opening"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initFilms(){
    document.querySelectorAll('.oa26-hero').forEach(function(hero){
      if(hero.dataset.oaFilmReady==='1')return;
      hero.dataset.oaFilmReady='1';
      var mq=window.matchMedia('(max-width: 749px)');
      var reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
      var button=hero.querySelector('.oa26-hero__play');
      var generation=0;
      function sync(){
        var token=++generation;
        hero.querySelectorAll('.oa26-hero__film').forEach(function(el){
          var vid=el.querySelector('video');
          if(vid){vid.pause();vid.controls=false;}
          el.hidden=true;
        });
        var selected=hero.querySelector(mq.matches?'.oa26-hero__film--mobile':'.oa26-hero__film--desktop');
        if(button)button.hidden=true;
        if(!selected){if(button)button.hidden=false;return;}
        var video=selected.querySelector('video');
        if(!video){if(button)button.hidden=false;return;}
        selected.hidden=false;
        video.muted=true;
        video.defaultMuted=true;
        video.setAttribute('muted','');
        video.setAttribute('playsinline','');
        video.playsInline=true;
        video.autoplay=true;
        video.loop=true;
        video.preload='metadata';
        if(reduced.matches){video.pause();if(button)button.hidden=false;return;}
        function fallback(){if(token!==generation)return;selected.hidden=false;if(button)button.hidden=false;}
        try{
          var attempt=video.play();
          if(attempt&&typeof attempt.then==='function')attempt.then(function(){if(token===generation&&button)button.hidden=true;}).catch(fallback);
        }catch(e){fallback();}
      }
      if(button)button.addEventListener('click',function(){
        var selected=hero.querySelector(mq.matches?'.oa26-hero__film--mobile':'.oa26-hero__film--desktop');
        if(!selected)return;
        var video=selected.querySelector('video');
        if(!video)return;
        selected.hidden=false;
        video.muted=true;
        video.setAttribute('playsinline','');
        video.playsInline=true;
        video.preload='auto';
        video.controls=true;
        var p=video.play();
        if(p&&typeof p.then==='function')p.then(function(){button.hidden=true;}).catch(function(){button.hidden=false;});
      });
      mq.addEventListener('change',sync);
      reduced.addEventListener('change',sync);
      sync();
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initFilms);else initFilms();
  document.addEventListener('shopify:section:load',initFilms);
})();

  } catch(e) { console.error(e); }
})();
})();
